import { TradingText } from '@trading-ui/core';
import TradingSelect from '@trading-ui/select';
import { useTranslation } from 'react-i18next';

import useAppStore from '@/store/app.store';

import { AppUtils } from '@/utils/app.utils';
import { ROLES } from '@/constants/roles';

import type { User } from '@/interfaces/app.interfaces';

import useSettingsStore from '../../store/useSettingsStore';

import * as styles from './CompanyDetailsActionBar.css';

type Props = {
  user: User;
};

export default function CompanyDetailsActionBar({ user }: Props) {
  const masters = useAppStore((state) => state.masters);
  const selectedCompany = useSettingsStore((state) => state.selectedCompany);
  const setSelectedCompany = useSettingsStore((state) => state.setSelectedCompany);

  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      {user.role === ROLES.MOEVE_ADMIN ? (
        <TradingSelect
          value={selectedCompany}
          options={AppUtils.formatCompaniesToSelectOptions(masters.companies)}
          onChange={(value) => setSelectedCompany(value)}
          label={t('settings.companyDetailsTab.company')}
          style={{ width: '250px' }}
        />
      ) : (
        <TradingText text={user.company?.name ?? ''} variant="h6" />
      )}
    </div>
  );
}
